/**
 * range
 *
 * Returns an array of numbers representing the range between the min and max using the step
 *
 * @param min
 * @param max
 * @param step
 * @returns
 */
export const range = (min: number, max: number, step = 1) =>
    Array.from({ length: (max - min) / step + 1 }, (_, i) => min + i * step);
